(function($, undefined) {
	
	'use strict';
	var formValidator;
	var submitJobBtn;
	var datePickerInput;

	var manageJob = function() {
		var form = $(this).closest('form');
		formValidator.validateForm(form);

		if (!form.hasClass('has-error')) {
			form.find('button, .btn').addClass('disabled');
			form.submit();
		}
	};

	var getPickerDate = function() {
		var dateSplitVal = $(this).val().split('/');
		var name = $(this).attr('name');
		var parent = $(this).closest('.fake-ctn');

		parent.find('input[data-name=' + name + 'DateYear]').val(dateSplitVal[0]);
		parent.find('input[data-name=' + name + 'DateMonth]').val(parseInt(dateSplitVal[1]) - 1);
		parent.find('input[data-name=' + name + 'DateDay]').val(dateSplitVal[2]);
	};
	
	var init = function () {
		formValidator = Fw.component.models().form;
		submitJobBtn = $('.submit-job-btn');
		datePickerInput = $('.datepicker');

		datePickerInput.change(getPickerDate);
		submitJobBtn.click(manageJob);

		if ($('html').attr('lang') === 'fr') {
			$.datetimepicker.setLocale('fr');
		}

		// individual pickers
		$('.datepicker').datetimepicker({
			timepicker:false,
			format:'Y/m/d',
			scrollInput: false
		});
	};
	
	$(window).on('load', function () {
		init();
	});
	
})(jQuery);
